import { Aeroplanta } from "../despacho/Aeroplanta";

export class Notificacion{
  documentos: number[];
  activo: boolean;
  aeroplantas: Aeroplanta[];
  emails:string[];
}
